Customer.Reports ||= {}

class Customer.Reports.TableReport

  constructor: (@json, @container) ->
    @dataTable = new google.visualization.DataTable()

  getOperatorsForFilter: ->
    _.map(@json.data, (data) -> data[0])

  getFirstColumnName: ->
    @json.columns[0].titleize()

  render: ->
    @dataTable.addColumn(@json.types[index], @json.columns[index].titleize()) for index in [0..(@json.columns.length-1)]
    @dataTable.addRows(@json.data)
    @_addCustomStyles() if @json.options.table_styles
    @dataTable.sort({column: @json.options.sort_column_index, desc: true}) if @json.options.sort_column_index
    @_addColorToColumns() if @json.options.columns?.color?
    @_addColorToRows() if (@json.options?.rows?.color?.color && (@json.options?.rows?.color?.index > -1))

    @_addTotalRow() if @json.options.show_totals

    new google.visualization.Table(@container).draw(@dataTable, width: $(@container).width(), allowHtml: true)

    columns = @json.columns
    $(@container).find('th').each((index) -> $(this).addClass(_.string.slugify(columns[index])))
    this

  filter: (value) =>
    @dataView = new google.visualization.DataView(@dataTable)
    if value != 'All'
      @dataView.setRows(@dataView.getFilteredRows([{column: 0, value: value}]));
    new google.visualization.Table(@container).draw(@dataView, width: $(@container).width(), allowHtml: true)
    this

  _addCustomStyles: ->
    columnIndexes = []
    for type, i in @json.types
      columnIndexes.push(i) if type?.toLowerCase() == 'number' && @json.columns.length > i

    for columnIndex in columnIndexes
      formatSettings = _.extend({}, { decimalSymbol: ',', groupingSymbol: '.', fractionDigits: 0 }, @json.options.table_styles[columnIndex] || {})
      formatter = new google.visualization.NumberFormat(formatSettings);
      formatter.format(@dataTable, columnIndex)

  _addColorToColumns: ->
    for i in [0..(@json.data.length-1)] by 1
      for j in [0..(@json.columns.length-1)] by 1
        option = _.find(@json.options.columns.color, (opt) => opt.name.toLowerCase() == @json.columns[j].toLowerCase())
        if option
          @dataTable.setProperty(i, j, 'style', "background-color: #{option.color};")

  _addColorToRows: ->
    return unless @json.data[0]
    for j in [0..(@json.columns.length-1)] by 1
      for i in [0..(@json.data[0].length-1)] by 1
        if j == @json.options.rows.color.index
          @dataTable.setProperty(j, i, 'style', "background-color: #{@json.options.rows.color.color};")

  _addTotalRow: ->
    totalData = ['TOTAL'].concat(0 for i in [1..(@json.columns.length-1)] by 1)
    for c in [1..(@json.columns.length-1)] by 1
      if @json.types[c] == 'number'
        for r in [0..(@json.data.length-1)] by 1
          totalData[c] += @json.data[r][c]
      else
        totalData[c] = ''
    @dataTable.addRow(totalData)
